import { render, staticRenderFns } from "./PrintRealNameTicket.vue?vue&type=template&id=820857e0&scoped=true&"
import script from "./PrintRealNameTicket.vue?vue&type=script&lang=js&"
export * from "./PrintRealNameTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820857e0",
  null
  
)

export default component.exports